import React from 'react';
import Titlebar from './Titlebar';
import { apiUrl } from './config';


function Stations() {
    // Generate station table like customer table 
    const [stations, setStations] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const fetchStations = async () => {
            try {
                const response = await fetch(apiUrl(`/station/all`));
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setStations(data);
            } catch (error) {
                console.error('Error fetching stations:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchStations();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    const handleClick = () => {
        console.log('Add Station');
        window.location.href = '/stationadd';
    };

    return (
        <div className="lg:pl-72 sm:ml-0 px-0 sm:px-0">
            <Titlebar title="Billboard: Stations" />
            <div className="m-3 px-4 sm:px-6 lg:px-8">
                <div className="mt-8 flow-root">

                    <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex sm:justify-end">
                        <button
                        type="button"
                        onClick={handleClick}
                        className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        >
                        Add Station
                        </button>
                    </div>

                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                            <table className="min-w-full divide-y divide-gray-300">
                                <thead>
                                    <tr>
                                        <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">Station Name</th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Call</th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Frequency</th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Band</th>
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Location</th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 bg-white">
                                    {stations.map((station) => (
                                        <tr key={station.id}>
                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">{station.name}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{station.call}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{station.frequency}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{station.band}</td>
                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{station.city}, {station.state}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Stations;